// Persistent store field
export default [
	// ['intl', ['currentLocale']],
	// ['themes', ['currentTheme']], // ['feature','path...']
	// ['users', ['viewer']],
]
